import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { OverviewComponent } from './components/overview/overview.component';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from '../../features/customers/services/customer.service';
import { ToastrService } from 'ngx-toastr';
import { DialogRef } from '@angular/cdk/dialog';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { UploadFileService } from '../../shared/services/file-upload.service';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { Location } from '@angular/common';
import { VendorService } from '../../features/vendors/services/vendor.service';
import { PermissionService } from '../../shared/services/permission.service';
import { ModuleIds } from '../../shared/permission-constants/permission-const';
// import { Permission } from '../../shared/services/permissions';
// import { PermissionDirective } from '../../shared/directives/permissions.directive';

@Component({
  selector: 'app-vendor-details',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatTabsModule,
    MatSelectModule,
    MatIconModule,
    MatMenuModule,
    OverviewComponent,
    ReactiveFormsModule,
    FormsModule,
    // PermissionDirective
  ],
  templateUrl: './vendor-details.component.html',
  styleUrl: './vendor-details.component.scss'
})
export class VendorDetailsComponent {
  search: any;
  allvendors: any;
  vendorId: string | null;
  selectedTabIndex: any = 0;
  selectedOption = 'accounts';
  readonly dialog = inject(MatDialog);
  isDropdownOpen = false;
  isAttacheFile = false;
  vendorDetails: any;
  comments: any;
  commentForm: FormGroup;
  fileName: any = null;
  file: any;
  documentDetails: any = [];
  fileUrl: any;
  uploadForm: FormGroup;
  selectedVendor: any;
  canAddVendor$ = this.permissionService.hasPermission(
    ModuleIds.Vendor,
    'Create'
  );
  canEditVendor$ = this.permissionService.hasPermission(
    ModuleIds.Vendor,
    'Edit'
  );

  constructor(
    private router: Router,
    private customerService: CustomerService,
    private vendorService: VendorService,
    private documentUploadService: UploadFileService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private location: Location,
    private permissionService: PermissionService,
  ) { }

  ngOnInit() {
    this.fetchVendors();
    this.route.queryParamMap.subscribe(params => {
      this.vendorId = params.get('id');
      if (this.vendorId) {
        console.log('this.vendorId',this.vendorId);
        // this.fetchComments();
        this.getVendorDetailsById(this.vendorId)
      }
    });

    this.commentForm = this.fb.group({
      comments: ['']
    });
    this.uploadForm = this.fb.group({
      file: ['']
    });

  }

  selectTab(index: number) {
    this.selectedTabIndex = index;
    this.selectedVendor = this.allvendors[index];
    if (this.selectedVendor) {
      this.router.navigate(['/vendors/vendor-details'], {
        queryParams: { id: this.selectedVendor?.id},
      });
    }
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }


  toggleDropdown(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  toggleAttachFile(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isAttacheFile = !this.isAttacheFile;
  }

  getVendorDetailsById(id: any) {
    this.vendorService.fetchVendorById(Number(id)).subscribe({
      next: (data: any) => {
        this.vendorDetails = data;
      },
      error: (error) => {
        this.toastr.error(error?.message);
      },
    });
  }

  viewDocument(url: any) {
    const token = localStorage.getItem('AUTH_TOKEN');
    fetch(url, {
      method: 'GET',
      headers: {
        'authorization': token ? `Bearer ${token}` : '',
      }
    })
      .then(response => response.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      })
      .catch(error => console.error('Error:', error));
  }

  fetchCustomers() {
    this.customerService.fetchCustomers(this.search).subscribe({
      next: (data: any) => {
        this.allvendors = data;
        if (this.vendorId) {
          const targetId = +this.vendorId;
          this.selectedTabIndex = this.allvendors.findIndex((c: any) => {
            return c.id === targetId;
          });
          if (this.selectedTabIndex === -1) {
            this.selectedTabIndex = 0;
          }
        } else {
          this.selectedTabIndex = 0;
        }
        this.selectedVendor = this.allvendors[this.selectedTabIndex] || {};
      },
      error: (error) => {
        this.toastr.error(error?.message);
      },
    });
  }

  fetchVendors() {
    this.vendorService.fetchVendors(this.search).subscribe({
      next: (data: any) => {
        this.allvendors = data;
        if (this.vendorId) {
          const targetId = +this.vendorId;
          this.selectedTabIndex = this.allvendors.findIndex((c: any) => {
            return c.id === targetId;
          });
          if (this.selectedTabIndex === -1) {
            this.selectedTabIndex = 0;
          }
        } else {
          this.selectedTabIndex = 0;
        }
        this.selectedVendor = this.allvendors[this.selectedTabIndex] || {};
      },
      error: (error) => {
        this.toastr.error(error?.message);
      },
    });
  }

  onEdit() {
    this.router.navigate([`/vendors/vendors-edit/${this.vendorId}`]);
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
  
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const allowedFileTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg', 'text/csv', 'application/msword'];
  
      if (allowedFileTypes.includes(file.type)) {
        this.file = file;
        this.fileName = this.file.name;
        this.onUpload();
      } else {
        alert('Invalid file type. Please select a valid file (PDF, JPEG, PNG, DOC, or CSV).');
        input.value = '';
      }
    }
  }

  // onFileSelected(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   if (input.files && input.files.length > 0) {
  //     const file = input.files[0];
  //     this.file = file;
  //     this.fileName = this.file.name;
  //     this.onUpload();
  //   }
  // }

  onUpload() {
    if (this.file) {
      this.documentUploadService.uploadDocument(this.file, 'customers').subscribe({
        next: (response) => {
          this.fileUrl = response.url;
          this.documentDetails = {
            partnerId: Number(this.vendorId),
            documentName: this.fileName,
            documentUrl: this.fileUrl,
          };
          this.onUploadDocument();
        },
        error: (error) => {
          this.toastr.error(error, 'Error');
        },
      });
    }
  }

  onUploadDocument() {
    if (this.vendorId) {
      this.customerService.createDocument(
        this.documentDetails
      ).subscribe({
        next: (data) => {
          if (data) {
            this.toastr.success('Document uploaded successfully', 'Success');
            this.getVendorDetailsById(this.vendorId);
          }
        },
        error: (error) => this.toastr.error(error, 'Error'),
      });
    }
  }

  onRemoveDocument(id: any) {
    if (id) {
      const dialogRef = this.dialog.open(ConfirmDialog);
      dialogRef.afterClosed().subscribe((result) => {
        if (result === true) {
          this.customerService.removeDocument(
            Number(id)
          ).subscribe({
            next: (data) => {
              if (data) {
                this.toastr.success('Document removed successfully', 'Success');
                this.getVendorDetailsById(this.vendorId);
              }
            },
            error: (error) => this.toastr.error(error, 'Error'),
          });
        }
      })
    }
  }

  fetchComments() {
    const loginEmployee: any = localStorage.getItem('loggedInUser');
    const employee = JSON.parse(loginEmployee);
    const employeeId = employee?.employeeData?.id;
    const conditions = {
      employeeId: employeeId,
      refId: Number(this.vendorId),
      type: 'Customer',
      activityType: 'Comment'
    }
    this.customerService.comments(conditions).subscribe({
      next: (data) => {
        if (data) {
          this.comments = data;
        }
      },
      error: (error) => {
        console.error(error, 'Error');
      }
    })
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    this.search = input.value;
    this.fetchVendors();
  }

  onComment() {
    const loginEmployee: any = localStorage.getItem('loggedInUser');
    const employee = JSON.parse(loginEmployee);
    const employeeId = employee?.employeeData?.id;
    const commentData = {
      employeeId: employeeId,
      refId: Number(this.vendorId),
      type: 'Customer',
      activityType: 'Comment',
      note: this.commentForm.value.comments
    }
    this.customerService.createComment(commentData).subscribe({
      next: (data) => {
        if (data) {
          this.toastr.success('Comment added successfully!', 'Success');
          this.commentForm.reset();
          // this.fetchComments();
        }
      },
      error: (error) => {
        console.error(error, 'Error')
      }
    })
  }

}



@Component({
  selector: 'upload-vendor-details-dialog',
  templateUrl: 'upload-vendor-details-dialog.html',
  styleUrls: ['./vendor-details.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule, 
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule
  ],
})
export class UploadClientDetailsDialog {
  file: any = null;
  uploadForm: FormGroup;

  constructor(
    private customerService: CustomerService,
    private toastr: ToastrService,
    private dialogRef: DialogRef,
    private fb: FormBuilder,
  ) { }

  ngOnInit(){
    this.uploadForm = this.fb.group({
      file: [null, Validators.required],
    });
    document.addEventListener('dragover', this.preventDefaultBehavior);
    document.addEventListener('drop', this.preventDefaultBehavior);
  }

  preventDefaultBehavior(event: DragEvent) {
    event.preventDefault();
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();

    if (event.dataTransfer?.files.length) {
      this.onFileSelected({ target: { files: event.dataTransfer.files } });
    }
  }

  onFileSelected(event: any): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      console.log('Selected file:', file);
      this.file = file;
    }
    this.uploadForm.get('file')!.updateValueAndValidity();

  }

  onUpload() {
    if(this.uploadForm.invalid){
      this.uploadForm.markAllAsTouched();
      return;
    }
    if (this.file) {
      this.customerService.bulkCreateCustomer(this.file).subscribe({
        next: (response) => {
          console.log(response);

          if (response && !response.errors) {
            this.toastr.success('Customers uploaded successfully!', 'Success');
            this.dialogRef.close(response);
          }
          else if (response?.errors) {
            this.toastr.error(response?.errors[0]?.message, 'Error');
          }
        },
        error: (error) => {
          this.toastr.error(error, 'Bulk customer creation failed');
          this.dialogRef.close();
        },
      });
    }
  }

  removeFile(): void {
    console.log('remove');

    this.file = null;
    const input = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (input) {
      input.value = '';
    }
    this.uploadForm.get('file')!.updateValueAndValidity();
  }

  ngOnDestroy() {
    document.removeEventListener('dragover', this.preventDefaultBehavior);
    document.removeEventListener('drop', this.preventDefaultBehavior);
  }
}

